import * as React from "react";
import { Select } from "antd";
import { ServiceContext } from "src/services/provider/Service.provider";
import { useContext, useState, SetStateAction, Dispatch, useEffect } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { EstadoCivilEnum } from "src/services/interfaces/trade/tradeOwner/EstadoCivilEnum";
import { ITradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { ICivilStatus } from "src/services/interfaces/trade/user-snapshot/ICivilStatus";
import { ICivilStatusCommonDomain } from "src/services/interfaces/trade/user-snapshot/ICivilStatusCommonDomain";

interface ISelectCivilStatus extends FormComponentProps {
  tradeOwner: ITradeOwner;
  onChange: Dispatch<SetStateAction<EstadoCivilEnum>>;
}

export const SelectCivilStatus: React.FC<ISelectCivilStatus> = ({
  tradeOwner,
  onChange,
  form
}) => {
  const { commonDomainService } = useContext(ServiceContext);
  const [selectList, setSelectList] = useState<ICivilStatus[]>([]);

  useEffect(() => {
    loadCivilStatus();
  }, []);

  function loadCivilStatus() {
    commonDomainService.getCivilStatus().then((resp: ICivilStatusCommonDomain) => {
      setSelectList(resp.civil_status_json);
    });
  }

  return (
    <>
      <PbrSelect
        name="Estado Civil"
        size="large"
        formItemProps={{ label: "Estado civil" }}
        showSearch
        formWrapper={form}
        value={tradeOwner?.civilStatus}
        onChange={e => onChange(e as EstadoCivilEnum)}
        placeholder="Estado civil"
        rules={[
          {
            required: true,
            message: "Informe o seu estado civil"
          }
        ]}
      >
        {selectList.map((e, i) => (
          <Select.Option key={i.toString()} value={e.description}>
            {e.description}
          </Select.Option>
        ))}
      </PbrSelect>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/CivilStatus/SelectCivilStatus.tsx